<template>
  <div class="app-header">
    <img alt="Vue logo" src="./assets/logo.png">
  </div>
  <MvQuiz />
</template>

<script>
import MvQuiz from "./components/MvQuiz.vue";

export default {
  name: 'App',
  components: {
    MvQuiz
  }
}
</script>

<style>
body {
  margin: 0;
}
.app-header {
  background-color:#472114;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
